export const environment = {
  production: false,
  domainApi: 'pos-gateway.siamese-sandbox.com',
  apiUrl: 'https://pos-gateway.siamese-sandbox.com',
  authService: '/auth',
  userService: '/user',
  roleService: '/role',
  selectSercvice: '/select',
  branchService: '/branch',
  menuSercvice: '/menu',
  jobSchedulesService: '/job-schedules',
  incomeService: '/income',
  reportService: '/reports/dashboard'
};
